jQuery('.load-more-events').on('click', function(e) {
    e.preventDefault()

    var load = jQuery(this)
    load.html('<i class="fas fa-spinner fa-spin"></i>')

    var type = jQuery('#rubrique-event').val()
    var page = parseInt(jQuery('#current-page').val())
    var pagemax = parseInt(jQuery('#max-page').val())
    var posts = parseInt(jQuery('#posts-page').val())
    // console.log('type : ' + type)
    // console.log('page : ' + page)
    // console.log('pagemax : ' + pagemax)
    // console.log('posts : ' + posts)
    jQuery.post(
        ajaxurl, {
            'action': 'load_more_events',
            'type': type,
            'page': page,
            'posts': posts
        },
        function(response){
            load.html("<span>Charger plus d'actualités</span>")
            page = page + 1
            jQuery('.articles').append(response)
            jQuery('#current-page').val(page)

            if ( page == pagemax ) {
                jQuery('.row-more').remove()
            }
        }
    )
})